import { useMemo } from 'react';

import { useCrumbs } from 'layout/MainLayout/components/Header/hooks';

export const useBreadcrumbs = () => {
  const crumbs = useCrumbs();

  return useMemo(
    () =>
      crumbs.map(({ title, to, isLoading }, index: number) =>
        crumbs.length - 1 === index
          ? { title, isLoading }
          : { title, isLoading, to },
      ),
    [crumbs],
  );
};
